function dm_nav() {
    "use strict";

    let $body = $('body');
    let $prevScrollpos = window.scrollY;
    let $header = $('header#nav-header'),
        $header_h = $header.outerHeight(true),
        $admin_bar_h = $body.hasClass('admin-bar') ? 32 : 0;

    let $nav_menu_cont = $header.find('.nav-menu-cont'),
        $nav_menu_cont_h = $nav_menu_cont.outerHeight(true);

    let $scroll_trigger = $header_h - $nav_menu_cont_h;

    console.log('>> dm_nav loaded');

    /* =========================
       SCROLL HEADER LOGIC
    ========================= */
    $(window).on('scroll', debounce(function () { 
        return false; // DISABLED
        let $currentScrollPos = window.scrollY;

        if ($currentScrollPos <= $admin_bar_h) {
            $body.css('padding-top', 0);
            $header.removeClass('scrolling-up scrolling-down').addClass('scrolled-top');
            $nav_menu_cont.removeAttr('style');
        }
        else if ($prevScrollpos > $currentScrollPos && $currentScrollPos > $admin_bar_h) {
            $body.css('padding-top', $nav_menu_cont_h);
            $header.removeClass('scrolled-top scrolling-down').addClass('scrolling-up');
            $nav_menu_cont.css('top', 0);
        }
        else if ($currentScrollPos > $header_h) {
            $body.css('padding-top', $nav_menu_cont_h);
            $header.removeClass('scrolling-up scrolled-top').addClass('scrolling-down');
            $nav_menu_cont.css('top', -$nav_menu_cont_h);
        }

        $prevScrollpos = $currentScrollPos;
    }, 5));

    function debounce(func, wait) {
        let timeout;
        return function () {
            let context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    /* =========================
       HASH SCROLL
    ========================= */
    if (window.location.hash) {
        let $hash = window.location.hash.replace(/#/, '');
        let $target = $('section[data-slug="' + $hash + '"]');
        if ($target.length) {
            $('html,body').animate({
                scrollTop: $target.offset().top
            }, 750, 'easeOutQuad');
        }
    }

    $('header ul.navbar-nav a').on('click', function () {
        let $link = $(this).attr('href');
        if ($link && $link.includes('#') && !$(this).hasClass('no-hash-scroll')) {
            let tempLink = document.createElement('a');
            tempLink.href = $link;

            if (tempLink.pathname === window.location.pathname) {
                let $hash = $link.substring($link.indexOf('#') + 1);
                let $target = $('section[data-slug="' + $hash + '"], footer[data-slug="' + $hash + '"]');
                if ($target.length) {
                    $('html,body').animate({ scrollTop: $target.offset().top }, 0);
                }
            }
        }
    });

    /* =========================
       OVERLAY MENU TOGGLE
    ========================= */
    let $menuToggle  = $('#menu-toggle');
    let $overlayMenu = $('#overlay-menu');

    $menuToggle.on('click', function () {
        $overlayMenu.toggleClass('active');
        $body.toggleClass('menu-open');
    });

    // Close on menu link click
    $overlayMenu.find('a').on('click', function () {
        $overlayMenu.removeClass('active');
        $body.removeClass('menu-open');
    });

    // Close on ESC
    $(document).on('keyup', function (e) {
        if (e.key === 'Escape') {
            $overlayMenu.removeClass('active');
            $body.removeClass('menu-open');
        }
    });

    // OPTIONAL: click outside to close
    /*
    $overlayMenu.on('click', function (e) {
        if ($(e.target).is('#overlay-menu')) {
            $overlayMenu.removeClass('active');
            $body.removeClass('menu-open');
        }
    });
    */
}

export { dm_nav };
